<template>
  <div
    class="privacyBox"
    v-html="
      convertToHTML(
        getLocalizedContent(privacy.attributes, 'Datenschutzerklaerung')
      )
    "
  ></div>
</template>

<script>
import { mapState } from "vuex";
import HTMLConversion from "@/mixins/HTMLConversionMixin.js";
import Localization from "@/mixins/LocalizationMixin.js";
export default {
  name: "PrivacyView",
  mixins: [HTMLConversion, Localization],
  computed: {
    ...mapState(["privacy", "curLang"]),
  },
};
</script>

<style lang="sass">
@import '@/assets/sass/main.sass'
.privacyBox
  @include cardBox()
  @include containerBox()
  h1
    color: $gold !important
    margin-bottom: 2rem
  h2
    font-size: 1.5rem !important
    margin-bottom: 1rem
  h3
    font-size: 1.3rem
    font-family: 'Mainfont-Bold'
  h4
    font-size: 1.25rem
</style>
